/**
 * @file dispatchAnswerSingle.ts
 * Exports a method to add a submitted answer to the answers within AppState.
 */
import { actionProps } from './dispatchAnswerSingle';

/**
 * Helper method that returns a lower and higher price in app context.
 *
 *
 * @param {Object} action
 *   Dispatch action object.
 *
 * @returns {Object}
 *   An updated object of answers data for AppState.
 */
export default (action: actionProps): object => {
  return {
    lowerPrice: action.value.lowerPrice,
    higherPrice: action.value.higherPrice,
  };
};
